export default __webpack_public_path__ + "static/media/om.8f661571.svg";